<template>
   <div class="recommendation" style="background:#fff;margin-top:30px;">
       <div class="goodsHallTitle"><p>项目推荐</p></div>
       <div class="citys">
           <span :class="{ active:myindex == 1000 }" @click="getData(1,1000)">全部</span>
           <span v-for="(item,index) in citys" :key="index" :class="{ active:myindex == index }" @click="getData(item,index)">{{ item.name }}</span>
       </div>   
       <div class="main-content" style="padding:0 20px"> 
            <div class="contentList" v-for="(item,index) in list" :key="index" v-if="index<6" @click="$router.push({ path:'/quetaDetail',query:{ id:item.id } })">
                <img :src="item.pictureUrl[0]" alt="" width="100%" height="auto"> 
                <div class="contentDiv">
                    <h3>{{ item.townName }}</h3>
                    <!--<h3>{{ item.countyName }}</h3>-->
                </div>
            </div> 
       </div>
       <div class="moreProject" @click="$router.push('/quetaHome')">更多项目<a-icon type="right" /></div>
   </div>    
</template>

<script>
export default {
    data(){
        return{
            citys:[],
            myindex:1000,
            query:{
              //townCode:''
              cityCode:''
            },
            list:[]
        }
    },
    created(){
         this.getCitys();
         
    },
    methods:{
        getCitys(){
           //获取市级列表 /portal/index/getCitys
           //获取乡镇级列表 /portal/index/getAreaByLevel
            this.$https.get('/portal/index/getAreaByLevel').then(res=>{
                 if(res.code == 200){
                     this.citys = res.rows;
          
                     this.getList();
                 }
            })
        },
        getData(item,index){
             this.query.townCode = item==1?'':item.code;
              // this.query.cityCode = item==1?'':item.code;

             this.myindex = index;
             this.getList();
        },
        getList(){
             // /portal/index/getProjectSecondRecommend:按市级编码推荐项目      
            // /portal/index/getProjectSecondRecommendByTownCode:按照乡镇编码推荐项目
            this.$https.get('/portal/index/getProjectSecondRecommendByTownCode',{params:this.query}).then(res=>{
                  if(res.code == 200){
                      res.rows.forEach(item => {
                           item.pictureUrl = item.pictureUrl.split(',');
                      });
                      this.list = res.rows;
                  }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.recommendation{
    width: 1300px;
    display: inline-block;
    margin-bottom: 30px;
    .goodsHallTitle{
        height: 80px;
        line-height: 80px;
        text-align: center;
        position: relative;
        p{
            font-size: 20px;
            color: #666;
        }
    }
    .citys{
        text-align: center;
        span{
            display: inline-block;
            margin-left: 10px;
            padding: 5px 10px;
            border: 1px solid #333;
            cursor: pointer;
            margin-bottom: 5px;
        }
        .active{
                background-color: #cf4640;
                border-color: #cf4640;
                color: #fff;
        }
    }
    .main-content{
        display: inline-block;
        width: 100%;
    }
    .contentList{
            float: left;
            width: 32%;
            margin:20px 1.33% 0 0;
            height: 350px;
            position: relative;
            overflow: hidden;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            background: black;
            .contentDiv{
                    position: absolute;
                    left: 0;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    h3{
                        color: #fff;
                        line-height: 50px;
                        text-indent: 30px;
                    }
                }
            
    }
    .moreProject{
        clear: both;
        width: 150px;
        margin: 20px auto 10px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        border: 1px solid #333;
        border-radius: 15px;
        cursor: pointer;
    }
}
</style>